export default __webpack_public_path__ + "manageJobs.html";